import { render, staticRenderFns } from "./PriceLevelEditor.vue?vue&type=template&id=25c1a95e&scoped=true&"
import script from "./PriceLevelEditor.vue?vue&type=script&lang=js&"
export * from "./PriceLevelEditor.vue?vue&type=script&lang=js&"
import style0 from "./PriceLevelEditor.vue?vue&type=style&index=0&id=25c1a95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1a95e",
  null
  
)

export default component.exports